import { Texture } from '@pixi/core';

function createTexture(base, loader, url) {
  const texture = new Texture(base);
  texture.baseTexture.on("dispose", () => {
    delete loader.promiseCache[url];
  });
  return texture;
}

export { createTexture };
//# sourceMappingURL=createTexture.mjs.map
